import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa'

function Message({ variant = 'info', children, autoClose = true, delay = 3000 }) {
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        if (autoClose) {
            const timer = setTimeout(() => setVisible(false), delay)
            return () => clearTimeout(timer)
        }
    }, [autoClose, delay])

    const getIcon = () => {
        switch (variant) {
            case 'success':
                return <FaCheckCircle className="me-2" />;
            case 'danger':
                return <FaExclamationTriangle className="me-2" />;
            case 'info':
            default:
                return <FaInfoCircle className="me-2" />;
        }
    }

    if (!visible) return null

    return (
        <Alert
            variant={variant}
            className="d-flex align-items-center shadow-sm rounded-3 py-2 px-3 fade show"
        >
            {getIcon()}
            <span className="flex-grow-1">{children}</span>
        </Alert>
    )
}

export default Message

            // function Message({ variant, children }) {
            //     return (
            //         <Alert variant={variant}>
            //             {children}
            //         </Alert>
            //     )
            // } 
            
            // export default Message
